/** The composer's pill trigger, fly-up menu and menu row — one register for every dial. */
export const PILL_CLASS =
  "h-7 rounded-full px-2 gap-1 text-xs font-medium transition-colors shrink-0 text-muted-foreground hover:text-foreground hover:bg-accent";

export const MENU_CLASS = "w-72 p-2 rounded-[14px] border";

// The app's base leaves <button> on the UA's default cursor outside the rail, so these say pointer.
export const ROW_CLASS =
  "w-full flex items-center gap-3 min-h-11 px-4 py-2 rounded-lg text-left transition-colors cursor-pointer hover:bg-accent disabled:pointer-events-none disabled:opacity-50";

/** A trigger in the line under the composer. */
export const FOOTER_TRIGGER_CLASS =
  "inline-flex min-w-0 items-center gap-1.5 rounded-md px-1.5 py-0.5 transition-colors cursor-pointer disabled:cursor-default";
